import { userTypes } from "../constantes/actionTypes"

const initialState = []

export const users = (state = initialState, action) => {
    switch (action.type) {
        case userTypes.GET_ALL_USERS_SUCCESS:
            return action.payload
        case userTypes.UPDATE_USER_SUCCESS:
            const updateUser = state.map(item => {
                if(item.id_Usuario === action.payload.id_Usuario) {
                    return action.payload
                }
                return item
            })
            return updateUser
        case userTypes.DELETE_USER_SUCCESS:
            return state.filter(x => x.id_Usuario !== action.payload)
        case userTypes.DELETE_USER_FAILURE: 
        case userTypes.UPDATE_USER_FAILURE:
            return state
        case userTypes.GET_ALL_USERS_FAILURE:
            return initialState
        default:
            return state
    }
}


